module.exports = __webpack_public_path__ + "assets/img/shiping.7a5ca131.png";